import React, { Component } from "react";
import "./snackbar.style.css";

import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import { Link } from "react-router-dom";

class Snackbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Booking_Id: props.Booking_Id,
      Message: props.message,
      isError: props.error,
      open: props.open,
      path: props.pathTo,
      setPayDialog:props.setPayDialog,
      setBookId:props.setBookId,
    };
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    this.setState({
      Booking_Id: props.Booking_Id,
      Message: props.message,
      isError: props.error,
      open: props.open,
      path: props.pathTo,
    });
  };
  handleOkClick = () => {
    this.props.close(this.state.isError); 
    console.log("Calling setPaymentDetails(true) from Snackbar");
    // this.props.setPaymentDetails(true);

  };
  
  render() {
    const { Booking_Id, Message, isError, open, path } = this.state;
    return (
      <React.Fragment>
        {open && (
          <React.Fragment>
            <div className="overlay-snack">
              <div className="snackbar">
                <div>
                  <div id="title" className={isError ? "error " : "success"}>
                    <div className="snackIconContainer">
                      {isError ? (
                        <AiOutlineCloseCircle className="snackIcon" />
                      ) : (
                        <AiOutlineCheckCircle className="snackIcon" />
                      )}
                    </div>
                  </div>

                  <div className="snackTitle">
                    {isError ? "Oops !" : "Success !"}
                  </div>
                  <div className="snackmessageContainer">
                    <p className="snackbar-msg-p">{Message ?? ""}</p>
                  </div>
                  <div className="snackbuttonContainer">
                    {path === null || path === undefined || path === "" ? (
                      <button
                        className={
                          isError
                            ? "error snackButtonClass"
                            : "success snackButtonClass"
                        }
                        // onClick={(e) => this.props.close(isError)}
                        onClick={this.handleOkClick}
                      >
                        OK
                      </button>
                    ) : (
                      <Link to={path}>
                        <button
                          className={
                            isError
                              ? "error snackButtonClass"
                              : "success snackButtonClass"
                          }
                          // onClick={(e) => this.props.close(isError)}
                        >
                          CONTINUE
                        </button>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default Snackbar;
